import { html } from '@shared/utils/rendering/html';
import { useAuth } from '@core/utils/context/authentication-context';
import { useFeatureChecks } from '@core/utils/features/feature-context';
import {
    createGuardedComponents,
    shouldShowReadOnlyView,
    isNewEvidenceCapture,
    isReopenedEvidence,
    isRejectedEvidence,
    isSubmittedEvidence,
    renderEvidenceComponent,
} from './helpers';

const SubcomponentCollapseInner = (rowData, filters) => {
    const { isReadOnly, user } = useAuth();
    const { useFeature } = useFeatureChecks();

    const canSelfReview = useFeature('evidence.canSelfReview', false);
    const canEditRejectedEvidence = useFeature('evidence.editOnReject', true);
    const guardedComponents = createGuardedComponents(rowData);

    // Read-only view (highest priority)
    if (shouldShowReadOnlyView(isReadOnly, filters, rowData)) {
        return html`<${guardedComponents.ReadOnly} rowData=${rowData} />`;
    }

    // New evidence capture
    if (isNewEvidenceCapture(filters, rowData)) {
        return html`<div class="card"><${guardedComponents.Capture} rowData=${rowData} /></div>`;
    }

    // Reopened — admin reset the record; user must re-upload to replace existing evidence
    if (isReopenedEvidence(filters, rowData)) {
        return html`<div class="card"><${guardedComponents.Edit} rowData=${rowData} /></div>`;
    }

    // Rejected evidence editing
    if (isRejectedEvidence(filters, rowData, canEditRejectedEvidence)) {
        return html`<div class="card"><${guardedComponents.Edit} rowData=${rowData} /></div>`;
    }

    // Submitted evidence (review/edit decision)
    if (isSubmittedEvidence(filters, rowData)) {
        return renderEvidenceComponent(guardedComponents, rowData, user, canSelfReview);
    }

    return null;
};

export default SubcomponentCollapseInner;
